import { string, object } from 'yup';
import { PriceSchema } from './CommonSchema';

const HotelSchema = object().shape({
  id: string().min(1).required(),
  name: string().required(),
  prices: object()
    .shape({
      rate: object()
        .shape({
          lead_price: object()
            .shape({
              base_rate: PriceSchema.required(),
            })
            .required(),
        })
        .required(),
    })
    .required(),
  gallery: object().required(),
});

export default HotelSchema;
